import userModule from "@/store/modules/user.module";
import { toaster } from "@/utilities/toaster";
import { Machine } from "xstate";
const addUserMachine = Machine({
    id: "addUserMachine",
    initial: "idle",
    states: {
        idle: {
            always: "gettingAddDetails",
        },
        gettingAddDetails: {
            invoke: {
                id: "gettingAddDetails",
                src: (context, event) => {
                    return userModule.AddUserDefaults();
                },
                onDone: { target: "loadedDetails" },
                onError: { target: "serviceUnavailable" },
            },
        },
        savingUser: {
            invoke: {
                id: "gettingAddDetails",
                src: (context, event) => {
                    return userModule.SaveUser(event.user);
                },
                onDone: { target: "savingUser", actions: "showAddMessage" },
                onError: { target: "loadedDetails" },
            },
        },
        loadedDetails: {
            on: {
                SAVE_USER: "savingUser",
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        showAddMessage: (context, event) => {
            toaster.ShowSuccess("User was created successfully.");
        },
    },
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default addUserMachine;
